import Humanize from 'humanize-plus';
import { Icon } from '@iconify/react';
import LoadingAnimation from '../loading/loading';

export const FileManagerFooter = ({consumption}) => {

    return (
        <div className="file-manager-sidebar-footer">
        {consumption ?
            <div className="d-flex align-items-center">
                <div className="mx-n1">
                    <Icon className="iconify fa-3x" icon="solar:ssd-square-bold-duotone" />
                </div>
                <div className="flex-1 ps-3 small">
                    <div className="fw-bold">Cloud Storage:</div>
                    <div className="progress h-5px my-1">
                        <div className="progress-bar progress-bar-striped bg-inverse" style={{ width: `${consumption.consumedPc.toFixed(2)}%` }}></div>
                    </div>
                    <div className="fw-bold text-body text-opacity-75">
                        <b className="text-body">{Humanize.fileSize(consumption.freeSpace)}</b> free of <b className="text-body">{Humanize.fileSize(consumption.capacity)}</b>
                    </div>
                </div>
            </div>
            :
            <LoadingAnimation />
        }
    </div>
    );

};